import { instanceToInstance } from "class-transformer";

export type IBaseData = {
  type: string
  getData(): BaseNodeModelData
}

export class BaseNodeModelData implements IBaseData {
  type!: string

  getData(): BaseNodeModelData {
    return instanceToInstance(this)
  }
}
